import React from "react";

import "./InvestorTagline.css"
function InvestorTagline() {
  return (
    <div className="InvestorTagline">
      <h1>INVESTMENT OPPORTUNITIES</h1>
      <div className="InvestorTagline__p">
        <p>
          At Cabrera Fine Properties, we believe in the power of partnership. We
          offer exciting “joint venture opportunities” for investors looking to
          gain financial returns on new projects. By collaborating with us, you
          can benefit from our expertise, resources, and an experience of
          success.
        </p>
      </div>
    </div>
  );
}

export default InvestorTagline;
